export default __webpack_public_path__ + "static/media/1669.25d9bc08.png";